import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ActivityMatterRatesService } from '../../../services/activity_matter_rates/activity-matter-rates.service';

@Component({
  selector: 'app-activity-matter-rates-show',
  templateUrl: './activity-matter-rates-show.component.html',
  styleUrls: ['./activity-matter-rates-show.component.css']
})
export class ActivityMatterRatesShowComponent implements OnInit, OnDestroy {
  constructor(
    private activityMatterRatesService: ActivityMatterRatesService,
    private route: ActivatedRoute
  ) {}

  routeSub: Subscription;
  activityMatterRate: any = {};
  id: number;
  editing: boolean = false;
  saving: boolean = false;
  saveError: string = '';
  form: any = {
    rate: null,
    is_global: false,
    rate_type_id: null
  };

  ngOnInit(): void {
    this.routeSub = this.route.params.subscribe((params: any) => {
      this.id = params?.id;
      this.loadActivityMatterRate();
    });
  }

  ngOnDestroy() {
    this.routeSub?.unsubscribe();
  }

  loadActivityMatterRate() {
    this.activityMatterRatesService.show(this.id).then(showSuccess => {
      this.activityMatterRate = { ...showSuccess };
      this.setFormValues();
    }).catch(showError => {
      console.log("showError", showError);
    });
  }

  setFormValues() {
    this.form = {
      rate: this.activityMatterRate?.rate,
      is_global: !!this.activityMatterRate?.is_global,
      rate_type_id: this.activityMatterRate?.rate_type_id
    };
  }

  edit() {
    this.saveError = '';
    this.setFormValues();
    this.editing = true;
  }

  cancel() {
    this.saveError = '';
    this.setFormValues();
    this.editing = false;
  }

  save() {
    this.saving = true;
    this.saveError = '';

    const params = {
      activity_matter_rate: {
        rate: this.form.rate,
        is_global: this.form.is_global,
        rate_type_id: this.form.rate_type_id
      }
    };

    this.activityMatterRatesService.update(this.id, params).then(updateSuccess => {
      this.activityMatterRate = { ...updateSuccess };
      this.setFormValues();
      this.editing = false;
    }).catch(saveError => {
      console.log("saveError", saveError);
      this.saveError = saveError?.error?.errors?.join(', ') || 'Unable to save Activity Matter Rate.';
    }).finally(() => {
      this.saving = false;
    });
  }
}
